import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonArea, ButtonVariant } from './Button';
export function renderButton(component, index, renderContentFunction) {
    const variant = mapVariant(component.properties.variant);
    return (_jsx(Button, { variant: variant, link: component.properties.link, submit: component.properties.submit === true, children: renderContentFunction && renderContentFunction(component) }));
}
export function renderButtonArea(component, index, renderContentFunction) {
    const variant = mapVariant(component.properties?.variant);
    return (_jsx(ButtonArea, { variant: variant, children: renderContentFunction && renderContentFunction(component) }));
}
function mapVariant(variant) {
    switch (variant) {
        case 'custom':
            return ButtonVariant.Custom;
        case 'simple':
            return ButtonVariant.Simple;
        case 'small':
            return ButtonVariant.Small;
        case 'normal':
            return ButtonVariant.Normal;
        default:
            return undefined;
    }
}
